import QueryString from 'qs'

const BASE_URL = 'ai-service/api/project-training'

const modelTrainingRequests = {
  trainProjectRequest: (data) => ({
    url: `${BASE_URL}/train/start`,
    method: 'post',
    data,
  }),
  deployIterationRequest: (data) => ({
    url: `${BASE_URL}/deploy/start`,
    method: 'post',
    data,
  }),
  deployIterationByAiModelIdRequest: (data) => ({
    url: `${BASE_URL}/deploy/start/ai-model`,
    method: 'post',
    data,
  }),
  deployIterationByVqaModelIdRequest: (data) => ({
    url: `${BASE_URL}/deploy/start/vqa-model`,
    method: 'post',
    data,
  }),
  getPagesStatisticsByFormsForProjectTrainingRequest: (data) => ({
    url: `${BASE_URL}/pages/statistics/forms`,
    method: 'post',
    data,
  }),
  getPagesStatisticsByAiObjectsForProjectTrainingRequest: (data) => ({
    url: `${BASE_URL}/pages/statistics/aiObjects`,
    method: 'post',
    data,
  }),
  getPagesForProjectTrainingRequest: (data) => ({
    url: `${BASE_URL}/project/pages`,
    method: 'post',
    data,
  }),
  getContentsForProjectRequest: (data) => ({
    url: `${BASE_URL}/project/contents`,
    method: 'get',
    params: data,
  }),
  getFormsForProjectRequest: (data) => ({
    url: `${BASE_URL}/project/forms`,
    method: 'get',
    params: data,
  }),
  getFormControlsForProjectRequest: (data) => ({
    url: `${BASE_URL}/project/form-controls`,
    method: 'get',
    params: data,
    paramsSerializer: (params) => QueryString.stringify(params, { arrayFormat: 'repeat' }),
  }),
  getUsersForProjectRequest: ({ searchQuery }) => ({
    url: `api/users?search=${encodeURIComponent(searchQuery)}`,
    method: 'get',
  }),
}

export default modelTrainingRequests
